import { MultiButtonProps } from '@ahc-digital/component-library';
import { C04MultibuttonlayoutCTAProps } from './C04MultibuttonlayoutCTA.types';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';
import { getKvpValue } from 'src/shared/field-utils';

export function GetMultibuttonlayoutCTAModel(
  props?: C04MultibuttonlayoutCTAProps
): MultiButtonProps {
  const { renderText, renderLink } = useConditionalRendering();
  const { params, fields } = props || {};

  return {
    headline: renderText(fields?.Heading, { required: true }),
    icon: getKvpValue(fields?.Icon),
    subHeading: renderText(fields?.Subheading),
    firstCTA: renderLink(fields?.FirstCTA, { required: true }),
    secondCTA: renderLink(fields?.SecondCTA),
    thirdCTA: renderLink(fields?.ThirdCTA),
    fourthCTA: renderLink(fields?.FourthCTA),
    backgroundColor: getDroplink(params?.Theme),
  };
}
